import { SLOTS_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export interface IAtHomeAvailableDoctor {
  staff?: {
    id: string;
    name: string;
    image_url?: string;
  } | null;
  tag?: {
    tag_text?: string;
    icon_url?: string;
  } | null;
}

interface IAtHomeAvailableDoctorsResponse {
  status?: boolean;
  message?: string;
  data?: IAtHomeAvailableDoctor[] | null;
}

interface IAtHomeAvailableDoctorsParams {
  customer_id: string;
  slot_date: string;
  latitude: string | number;
  longitude: string | number;
}

export const useAtHomeAvailableDoctorsAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [doctors, setDoctors] = useState<IAtHomeAvailableDoctor[]>([]);

  const execute = useCallback(
    async (params: IAtHomeAvailableDoctorsParams) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IAtHomeAvailableDoctorsResponse> = await axios.get(
          SLOTS_APIS?.AT_HOME_AVAILABLE_DOCTORS?.baseURL ?? "",
          {
            params,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (res?.data?.status === false) {
          setDoctors([]);
          return;
        }

        setDoctors(res?.data?.data ?? []);
      } catch (e: any) {
        const axiosError = e as AxiosError;
        sendCurl(axiosError.config?.["curlCommand"]);
        captureError(axiosError);
        setDoctors([]);
        toast.error("Server Error: " + e.message);
      }
    },
    [configuration, captureError, sendCurl],
  );

  return { execute, doctors };
};
